import React, { useEffect, useLayoutEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"

import sorryIllustration from "../../../images/sorry-illustration.png"
import Img from "../../../utils/OptimizedImage"
import Button from "../../Button"

const DisplayJobs = ({ filters, currentJobs, loading, setLoading }) => {
  let amountOfJobs

  const findAmountOfJobs = () => {
    if (currentJobs) {
      amountOfJobs = 0
      Object.keys(currentJobs).forEach((depts) => {
        currentJobs[depts].forEach(() => {
          amountOfJobs++
        })
      })
    }
  }
  findAmountOfJobs()

  let deptAmount

  const findAmountofDepts = () => {
    if (filters?.selectedDepartments?.length === 1) {
      deptAmount = `${filters?.selectedDepartments?.length} department`
    } else if (filters?.selectedDepartments?.length > 1) {
      deptAmount = `${filters?.selectedDepartments?.length} departments`
    } else {
      deptAmount = "all departments"
    }
  }
  findAmountofDepts()

  let locationAmount

  const findAmountOfLocations = () => {
    if (filters?.selectedCountries?.length === 1) {
      locationAmount = `${filters?.selectedCountries?.length} location`
    } else if (filters?.selectedCountries?.length > 1) {
      locationAmount = `${filters?.selectedCountries?.length} locations`
    } else {
      locationAmount = "all locations"
    }
  }
  findAmountOfLocations()

  useEffect(() => {
    setLoading(true)
  }, [])

  useLayoutEffect(() => {
    findAmountOfJobs()
    // prevents the flash of "no jobs" on first render
    const timer = setTimeout(() => setLoading(false), 250)
    return () => clearTimeout(timer)
  }, [currentJobs])

  useLayoutEffect(() => {
    findAmountofDepts()
    findAmountOfLocations()
  }, [filters])

  if (loading) {
    return <p>Loading Jobs...</p>
  } else {
    return (
      <>
        {currentJobs && (
          <p className="job-stats">
            <b>{amountOfJobs}</b> roles across <b>{deptAmount}</b> and{" "}
            <b>{locationAmount}</b>
          </p>
        )}
        {currentJobs &&
          Object.keys(currentJobs)
            .sort()
            .map((department) => (
              <Container className="department" key={department}>
                <p className="subheading department-title">{department}</p>

                {currentJobs[department].map((job) => (
                  <Container className="job-listing" key={job?.id}>
                    <Row className="job-row">
                      <Col md={8} className="job-info">
                        <h3 className="job-title">{job?.title}</h3>
                        <p className="job-dept">{job?.department}</p>
                        {job?.offices[0] && (
                          <p>
                            {job?.offices[0]?.name}, {job?.offices[0]?.location}
                          </p>
                        )}
                      </Col>
                      <Col className="job-link">
                        <Button
                          variant={"light-blue"}
                          link={job?.absolute_url}
                          newtab={true}
                        >
                          View More
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                ))}
              </Container>
            ))}
        {amountOfJobs === 0 && (
          <div className="no-jobs">
            <Img src={sorryIllustration} alt={"Illustration that says sorry"} />
            <p>There are no current openings.</p>
          </div>
        )}
      </>
    )
  }
}

export default DisplayJobs
